module.exports = __webpack_public_path__ + "img/naviki.67feddcf.png";